import { initAnalytics } from 'src/lib/analytics';

initAnalytics();
